import axios from 'axios';

export const api = axios.create({
	baseURL: import.meta.env.VITE_API_URL + '/consulta-preco/v1',
	withCredentials: true,
});

// interceptor de erro (equivalente ao beforeError)
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response) {
			return Promise.reject({
				status: error.response.status,
				data: error.response.data,
			});
		}

		return Promise.reject(error);
	},
);
